import PropTypes from 'prop-types';
import { memo, useMemo } from 'react';

import { ReactComponent as LightLogo } from '../../assets/logo-light.svg';
import { ReactComponent as Logo } from '../../assets/logo.svg';
import { ReactComponent as VinmecLogo } from '../../assets/vinmec.svg';
import GpacsLogoSrc from '../../assets/gpacs.png';
import GpacsLogoLightSrc from '../../assets/gpacs-light.png';

import { useThemeContext } from './ThemeProvider';

export const GpacsLogo = ({...rest}) => {
  return (
    <img src={GpacsLogoSrc} alt="gpacs" style={{ height: 72 }} {...rest} />
  );
};

export const GpacsLogoLight = ({...rest}) => {
  return (
    <img src={GpacsLogoLightSrc} alt="gpacs" style={{ height: 72 }} {...rest} />
  );
};

const LogoMapping = {
  default: {
    light: LightLogo,
    dark: Logo,
  },
  vinmec: {
    light: VinmecLogo,
    dark: VinmecLogo,
  },
  gpacs: {
    light: GpacsLogo,
    dark: GpacsLogoLight,
  }
};

const VindocLogo = ({ imgSrc }) => {
  const { theme } = useThemeContext();

  const origin = window.AGENCY || 'default';

  const LogoSrc = useMemo(() => {
    const themeDefinition = LogoMapping[origin];
    return imgSrc ? imgSrc : themeDefinition?.[theme] || Logo;
  }, [imgSrc, origin, theme]);

  // return React.createElement(LogoSrc);
  return (
    <LogoSrc
      style={{
        height: 32,
      }}
    />
  );
};

VindocLogo.propTypes = {
  imgSrc: PropTypes.string,
};

export default memo(VindocLogo);
